"use client";

import { useEffect, useRef, useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";
import { useAppDispatch, useAppSelector } from "@/hooks/hooks";
import { getAllActiveFAQ } from "@/services/aboutUs.services";

export default function FAQ({ cmsData }: { cmsData?: any }) {
  const dispatch = useAppDispatch();
  const { FAQList } = useAppSelector((state) => state.aboutUs);
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const hasDispatched = useRef(false);

  useEffect(() => {
    if (hasDispatched.current) return;
    if (!FAQList || FAQList.length === 0) {
      hasDispatched.current = true;
      dispatch(getAllActiveFAQ());
    }
  }, [dispatch, FAQList]);

  const rawFAQs = FAQList && FAQList.length > 0 ? FAQList : [];

  // Filter out resort-specific FAQs for the general list
  const generalFAQs = rawFAQs.filter((f: any) => !f.ResortID);

  // Normalize fields coming from the API (Question, Answer)
  const faqs = generalFAQs.map((f: any) => ({
    question: f.Question || f.question || "",
    answer: f.Answer || f.answer || "",
  }));

  if (faqs.length === 0) {
    return null;
  }

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-4xl mx-auto px-4">
        {cmsData?.Template ? (
          <div
            dangerouslySetInnerHTML={{ __html: cmsData.Template }}
            className="text-center mb-12"
          />
        ) : (
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl mb-4 font-sans font-bold text-gray-900">
              Frequently Asked{" "}
              <span className="bg-gradient-to-r from-yellow-400 via-pink-500 to-purple-600 bg-clip-text text-transparent">
                Questions
              </span>
            </h2>
          </div>
        )}

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-white rounded-xl shadow-md overflow-hidden border border-gray-100/80 transition-all duration-300"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between p-6 text-left hover:bg-gray-50/50 transition cursor-pointer font-sans"
              >
                <span className="text-lg pr-8 font-medium text-gray-800">
                  {faq.question}
                </span>
                {openIndex === index ? (
                  <ChevronUp className="w-6 h-6 text-pink-500 flex-shrink-0" />
                ) : (
                  <ChevronDown className="w-6 h-6 text-gray-400 flex-shrink-0" />
                )}
              </button>

              {openIndex === index && (
                <div className="px-6 pb-6">
                  <p className="text-gray-600 leading-relaxed">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
